import { Chart } from '@/lib/model';
import * as React from 'react';
import './index.scss';

export interface ChartsProps {
  data: Chart[];
}

const Result: React.FC<Chart> = ({
  label,
  result,
  fillColor,
  innerResults,
}) => (
  <div className="Charts__result">
    <div className="Charts__result__head">
      <div>
        <span className="Charts__result__head__label">{label}</span>
      </div>
      <div>
        <span className="Charts__result__head__value">{`${result}%`}</span>
      </div>
      <div
        className="Charts__result__head__percentage"
        style={{ backgroundColor: fillColor, width: `${result}%` }}
      />
    </div>
    <div className="Charts__result__inner">
      {innerResults?.map((inner, i) => (
        <div className="Charts__result__inner__result" key={i.toString()}>
          <div>
            <span className="Charts__result__inner__label">{inner.label}</span>
          </div>
          <div>
            <span className="Charts__result__inner__value">{`${inner.result}%`}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const Charts: React.FC<ChartsProps> = ({ data }) => (
  <div className="Charts">
    <span className="Charts__label">
      Risultati Elezioni 2018 in questo collegio:
    </span>
    <div className="Charts__results">
      {data.map((chart, i) => (
        <Result {...chart} key={i.toString()} />
      ))}
    </div>
    <p className="Charts__information">
      I risultati sono stati ricalcolati per rispecchiare il nuovo disegno dei
      collegi
    </p>
  </div>
);
